export default {
  // 表格列标题
  columns: {
    mainRouteCode: '主航线代码',
    airlineName: '航线名称',
    belongingAlliance: '归属联盟',
    portOfAffairs: '挂靠港口',
    coCabinParty: '共舱方',
    enabled: '状态'
  },

  // 按钮文本
  buttons: {
    addRoute: '新增航线',
    refresh: '刷新',
    detail: '详情',
    edit: '编辑',
    more: '更多',
    enable: '启用',
    disable: '禁用',
    back: '返回',
    save: '保存基本信息',
    saveChanges: '保存',
    cancel: '取消',
    addPort: '添加港口',
    addAgent: '添加船代',
    delete: '删除',
    update: '更新',
    addSchedule: '添加船期',
    addSpaceSharing: '添加共舱方',
    addTransitPort: '添加中转港',
    supplementFields: '补充字段',
    addNow: '立即添加'
  },

  // 消息提示
  messages: {
    routeMaintenanceData: '航线维护数据',
    dataLoadFailed: '数据加载失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    enableSuccess: '启用成功',
    enableFailed: '启用失败',
    disableSuccess: '禁用成功',
    disableFailed: '禁用失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    loadDataFailed: '加载数据失败',
    longTermScheduleUpdateSuccess: '长期船期更新成功',
    longTermScheduleUpdateFailed: '长期船期更新失败',
    basicInfoSaveSuccess: '基本信息保存成功',
    basicInfoSaveFailed: '基本信息保存失败'
  },

  // 确认对话框
  confirmDialog: {
    deleteTitle: '删除',
    deleteContent: '确定要删除该航线吗？',
    operationTitle: '确认操作',
    enableContent: '确定要启用航线 {name} 吗？',
    disableContent: '确定要禁用航线 {name} 吗？',
    confirm: '确定',
    cancel: '取消'
  },

  // 状态文本
  status: {
    enabled: '启用',
    disabled: '禁用',
    unknown: '未知',
    draft: '草稿',
    published: '已发布'
  },

  // 其他文本
  other: {
    allPorts: '全部挂靠港口',
    count: '个',
    allParties: '所有共舱方: ',
    currentStatus: '当前状态：',
    description: '说明：',
    port: '港口:',
    loading: '加载中...',
    unit: '个'
  },

  // 联盟名称
  alliance: {
    twoM: '2M联盟',
    ocean: '海洋联盟',
    the: 'THE联盟',
    independent: '独立运营'
  },

  // Tab标签页
  tabs: {
    basicInfo: '基本信息',
    longTermScheduleInfo: '长期船期'
  },

  // 长期船期相关
  longTermSchedule: {
    title: '长期船期',
    tableHeaders: {
      shipName: '船名',
      operator: '操船方',
      internalVoyage: '内部航次',
      customsVoyage: '报关航次'
    },
    placeholders: {
      selectShip: '请选择船名',
      selectOperator: '请选择操船方',
      enterInternalVoyage: '请输入内部航次',
      enterCustomsVoyage: '请输入报关航次',
      selectETA: '选择ETA',
      selectETD: '选择ETD',
      selectCustomsClearanceTime: '请选择截关时间',
      selectAntiTerrorTime: '请选择截反恐申报时间',
      selectVGMTime: '请选择截VGM时间',
      selectDocumentTime: '请选择截单时间',
      selectOOGListTime: '请选择截OOG List时间',
      selectDangerousTime: '请选择截危申报时间',
      selectSpaceSharing: '请选择共舱方',
      enterInternalVoyageModal: '请输入内部航次',
      enterCustomsVoyageModal: '请输入报关航次'
    },
    emptyStates: {
      noScheduleInfo: '暂无船期信息，请点击"添加船期"按钮添加',
      noSpaceSharingInfo: '暂无共舱方航次信息',
      noTransitPortInfo: '暂无中转港信息'
    },
    modal: {
      title: '补充字段设置',
      spaceSharingTitle: '共舱方航次',
      spaceSharingNumber: '共舱方 #{number}'
    },
    transitPort: {
      title: '中转港',
      ordinal: '第{number}中转港',
      port: '港口',
      routeCode: '航线',
      vesselName: '船名',
      voyage: '航次',
      portPlaceholder: '请选择中转港口',
      routeCodePlaceholder: '请输入航线代码',
      vesselNamePlaceholder: '请输入船名',
      voyagePlaceholder: '请输入航次',
      duplicateWarning: '该港口已被选择，中转港不能重复',
      duplicateError: '中转港口不能重复，请修改后再保存'
    },
    cutoffLabels: {
      customsClearance: '截关日',
      antiTerrorDeclaration: '截反恐申报',
      vgm: '截VGM',
      document: '截单',
      oogList: '截OOG List',
      dangerousGoods: '截危申报'
    },
    descriptions: {
      main: '船名来自基础资料，操船方来自当前航线的共舱方，港口来自基本信息中的挂靠港信息。ETA/ETD填写后该格子会高亮显示。添加第二行及后续船期时，ETA/ETD将自动在上一行对应港口日期基础上加7天。',
      spaceSharing: '默认时间根据ETA和基本信息中对应港口的设置自动计算，您可以根据实际情况调整。共舱方来自基本信息中的共舱方设置。',
      transitPort: '中转港信息用于记录航线的中转港口、航线代码、船名和航次等信息。删除中转港后，后续编号会自动顺位调整。'
    }
  },

  // 详情页面相关
  detail: {
    // 页面标题
    pageTitle: {
      create: '新增航线',
      edit: '编辑航线',
      view: '航线详情'
    },

    // 区域标题
    sections: {
      basicInfo: '基本信息',
      portInfo: '挂靠港口信息',
      agentInfo: '船代信息',
      statusInfo: '状态信息'
    },

    // 表单标签
    labels: {
      mainRouteCode: '主航线代码',
      airlineName: '航线名称',
      belongingAlliance: '归属联盟',
      coCabinParty: '共舱方',
      carrier: '船公司',
      internalRouteCode: '内部航线代码',
      port: '港口',
      dock: '挂靠码头',
      customsClearanceDay: '截关日',
      antiTerrorDeclarationDay: '截反恐申报',
      documentDay: '截单',
      departureDateDay: '开船日',
      vgmDay: '截VGM',
      oogListDay: '截OOG List',
      dangerousGoodsDeclarationDay: '截危申报',
      cabinShippingAgency: '舱位船代',
      dangerousGoodsShippingAgent: '危险品船代',
      status: '状态',
      createTime: '创建时间',
      updateTime: '更新时间'
    },

    // 占位符文本
    placeholders: {
      mainRouteCode: '请输入航线代码，如：AE7',
      airlineName: '请输入航线名称，如：亚欧7号',
      belongingAlliance: '请选择归属联盟',
      coCabinParty: '请选择共舱方（最多10个）',
      selectCarrier: '请选择船公司',
      internalRouteCode: '请输入内部航线代码（如：AE001）',
      selectWeekday: '请选择周几',
      selectTime: '12:00',
      selectCoCabinParty: '请选择共舱方',
      selectCabinAgent: '请选择舱位船代',
      selectDangerousAgent: '请选择危险品船代'
    },

    // 验证消息
    validation: {
      mainRouteCodeRequired: '请输入主航线代码',
      mainRouteCodeMaxLength: '航线代码最多10个字符',
      mainRouteCodeFormat: '航线代码只能包含大写字母和数字',
      airlineNameRequired: '请输入航线名称',
      belongingAllianceRequired: '请选择归属联盟',
      coCabinPartyRequired: '请选择共舱方',
      carrierRequired: '请选择船公司',
      internalRouteCodeRequired: '请输入内部航线代码',
      internalRouteCodeFormat: '内部航线代码应为2-20位大写字母和数字组合',
      maxSpaceSharingLimit: '已达到最大共舱方数量限制（20组）',
      duplicateSpaceSharing: '该船公司已存在，请选择其他船公司',
      portRequired: '请选择港口'
    },

    // 帮助文本
    helpText: {
      mainRouteCodeFormat: '航线代码只能包含大写字母和数字'
    },

    // 空状态文本
    emptyState: {
      noPortInfo: '暂无港口信息',
      noAgentInfo: '暂无船代信息',
      noSpaceSharing: '暂无共舱方信息',
      clickToAddSpaceSharing: '点击此处或"添加共舱方"按钮开始添加合作伙伴'
    },

    // 动态文本
    dynamic: {
      portNumber: '港口{number}',
      agentNumber: '船代{number}',
      spaceSharingNumber: '共舱方 {number}'
    },

    // 导出相关
    export: {
      portPrefix: '港口'
    }
  }
}
